
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const __APP_VERSION__: string;

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const __BUILD_TIME__: number;

export const VERSION = __APP_VERSION__;
export const BUILD = __BUILD_TIME__;
